/**
 * PipelineConnector.js — Vertical connector line between pipeline sections
 *
 * Renders a simple downward arrow between WHEN/PAY/THEN sections
 * to visually communicate the sequential flow.
 */

const PipelineConnector = () => (
  <div className="flex justify-center py-1">
    <div className="flex flex-col items-center">
      <div className="w-0.5 h-4 bg-gray-600" />
      <div className="text-gray-500 text-xs">&#9660;</div>
    </div>
  </div>
);

export default PipelineConnector;
